import React from 'react'
import MenuItem from './MenuItem'
import {Menu} from '@mui/material'
import {setLocale} from 'localization/i18n'
import {useDispatch} from 'react-redux'
import {setLanguage, useIsRtl} from 'store/Store'

// import storage from 'services/storage'

const MenuLanguage = ({anchorEl, isMenuOpen, handleMenuClose}) => {
    const dispatch = useDispatch()
    // useEffect(() => {
    //     dispatch(setLanguage(storage.getLanguage()))
    // }, [setLanguage])
    const handleOnClick = (lang) => {
        dispatch(setLanguage(lang))
        setLocale(lang)
        handleMenuClose()
    }
    const isRtl = useIsRtl()
    return (
        <Menu
            anchorEl={anchorEl}
            keepMounted
            open={isMenuOpen}
            onClose={handleMenuClose}
            slotProps={{
                paper: {
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&::before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                },
            }}
            transformOrigin={{horizontal: isRtl ? 'left' : 'right', vertical: 'top'}}
            anchorOrigin={{horizontal: isRtl ? 'left' : 'right', vertical: 'bottom'}}>
            <MenuItem onClick={() => handleOnClick('he')} title={'עברית'} />
            <MenuItem onClick={() => handleOnClick('en')} title={'English'} />
        </Menu>
    )
}

export default MenuLanguage
